export const contactData = [
  {
    label: 'E-mail',
    value: 'digitaleconomy@163.com',
  },
  {
    label: 'Tel',
    value: '+86 0571 8853 5382',
  },
  {
    label: 'Mobile',
    value: '+86 152 6850 6742',
  },
];

export const location = [
  {
    name: '未来科技城办公室',
    address: '浙江省杭州市文一西路998号海创园18号楼702A',
    latlng: {
      lat: 30.274232,
      lng: 119.979537,
    },
    imgList:
      'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/about/contact/weilaikeji.png',
  },
  {
    name: '钱江世纪城办公室',
    address: '浙江省杭州市萧山区宁围街道利一路188号天人大厦8F 801',
    latlng: {
      lat: 30.239145,
      lng: 120.239821,
    },
    imgList:
      'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/about/contact/tianrendasha.png',
  },
];
